module.exports = __webpack_public_path__ + "assets/images/template/project/sars_wuhan_comparison/mobile.svg?v=c4649209";